import { Typography, Link } from "@mui/material";

export default function SimCard() {
  return (
    <>
      <Typography>
        請依個人需要的流量、想去旅遊的國家來比較，特別注意的是英國、瑞士等，找網路近期的評價來選擇。
      </Typography>
      <ul>
        <li>
          台灣可買
          <ul>
            <li>
              Orange：
              <Link
                href="https://reurl.cc/60Evd6"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://reurl.cc/60Evd6
              </Link>
              <ul>
                <li>個人推薦，可線上註冊變預付卡，目前也有活動</li>
              </ul>
            </li>
            <li>
              DJB：
              <Link
                href="https://reurl.cc/V1jzYN"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://reurl.cc/V1jzYN
              </Link>
            </li>
          </ul>
        </li>
        <li>
          德國可買
          <ul>
            <li>
              sim.de：
              <Link
                href="https://www.sim.de?kw=QTo4DATGs8wCpRSLdrzV0g%3D%3D"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://www.sim.de?kw=QTo4DATGs8wCpRSLdrzV0g%3D%3D
              </Link>
              <ul>
                <li>
                  O2線路，最便宜的選擇，用上方推薦連結申請有20歐獎金，若申辦成功可聯絡我(n9102125@gmail.com)平分獎金，另黑五時有機會有活動，可免除每月可取消方案費用20歐。
                </li>
              </ul>
            </li>

            <li>
              O2：
              <Link
                href="https://reurl.cc/3YjX6L"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://reurl.cc/3YjX6L
              </Link>
              <ul>
                <li>有限時方案 ~9/5 15歐15GB的預付卡 到05.09.之前都可以辦!</li>
              </ul>
            </li>
            <li>
              ALDI TALK：
              <Link
                href="https://reurl.cc/60Ever"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://reurl.cc/60Ever
              </Link>
              <ul>
                <li>ALDI超市就能買，28天收費一次</li>
              </ul>
            </li>
            <li>
              Simon：
              <Link
                href="https://reurl.cc/NRpQ3q"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://reurl.cc/NRpQ3q
              </Link>
              <ul>
                <li>Vodafone線路，8GB攜碼€8.99</li>
              </ul>
            </li>
            <li>
              fraenk：
              <Link
                href="https://reurl.cc/7pe0Z1"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://reurl.cc/7pe0Z1
              </Link>
              <ul>
                <li>€10有7GB，認證需要居留卡</li>
              </ul>
            </li>
            <li>
              freenet-funk：
              <Link
                href="https://reurl.cc/7ped91"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://reurl.cc/7ped91
              </Link>
              <ul>
                <li>有吃到飽</li>
              </ul>
            </li>
            <li>
              Lidl connect：
              <Link
                href="https://reurl.cc/1mm4YW"
                underline="hover"
                target="_blank"
                rel="noopener"
              >
                https://reurl.cc/1mm4YW
              </Link>
              <ul>
                <li>
                  vodafone 空卡9.99€現在有特價～8/28 上官網買只要4.99€免運費
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <Typography>🔴 Tips：</Typography>
      <ul>
        <li>
          有些手機可支援E-SIM，可以將台灣的門號改為e-sim
          並開啟國際漫遊(非數據漫遊)，即可插歐洲sim卡還能收台灣簡訊及電話。
        </li>
        <li>有聽說telekom的網路好像台灣部分銀行app連不上，需要VPN。</li>
        <li>
          建議還是上網爬一下使用心得，不一定吃哪一家的電信訊號就很好，也要注意一下細部的規定及可使用的國家。
        </li>
      </ul>
    </>
  );
}
